export default function validateCompanyEmail(email: string) {
  const emailSuffixList = [
    'evolutivelabs.com',
    'evolutivelab.com',
    'kroma.me',
    'kroma.tw',
    'minimanstudio.com',
    'mykroma.fr',
    'rhinoshield.com.es',
    'rhinoshield.de',
    'rhinoshield.fr',
    'rhinoshield.in',
    'rhinoshield.io',
    'rhinoshield.jp'
  ]
  const pattern = `.+@${emailSuffixList.join('|')}$`
  return new RegExp(pattern).test(email)
}
